import { TSessionDetails } from '@api/io/session.io';
import { useConfigContext } from '@fe-core';
import { getSessionStates } from '@routes/session-details/utils/getSessionStates';

export const useSessionStates = (sessionDetails: TSessionDetails) => {
  const { config } = useConfigContext();

  return getSessionStates(sessionDetails, config.webfeatures);
};
